<template>
  <div class="home" id="home">
    <Header />
    <section id="about">
      <div class="sub-title">
          <h2>Une équipe de <span>spécialistes</span> à votre service.</h2>
      </div>
      <div class="wrap1140">
        <!-- <h2>Partenaires</h2> -->
        <div class="about-content">
          <div class="section-header">
            <span class="section-title">about</span>
            <h3>Nos prestations vous accompagnent <br> de <span class="color-blue">A</span> à <span class="color-blue">Z</span> dans vos projets.</h3>
          </div>
          <div class="about-content-col">
            <div>
              <img src="@/assets/images/description-3.png" alt="">
              <h4>Analyse des besoins</h4>
              <p>Nous vous conseillons pour faire les bons choix et vous apporter des outils adaptés à vos besoins.</p>
            </div>
            <div>
              <img src="@/assets/images/description-2.png" alt="">
              <h4>Graphisme et Design</h4>
              <p>Réalisation graphique sur mesure ou selon le cahier des charges de votre entreprise.</p>
            </div>
            <div>
              <img src="@/assets/images/description-1.png" alt="">
              <h4>Développement</h4>
              <p>Votre site internet ou votre application sera développé(e) avec les dernières technologies.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="services">
      <div class="wrap1140">
        <div class="services-content">
          <div class="section-header">
            <span class="section-title">services</span>
            <h3>Rien n'est impossible avec Geneva Web!</h3>
            <p>Gestion de projet, conception, design, développement, conseil ... <br> Notre expertise saura vous guider et vous accompagner tout au long de vos projets.</p>
          </div>
          <div class="services-content-container">
            <Tab />
          </div>
        </div>
      </div>
    </section>
    <section id="partners">
      <div class="wrap1280">
        <div class="partenaires-content">
          <div class="section-header">
            <span class="section-title">partenaires</span>
            <h3>Geneva Web, une collaboration entre entreprise!</h3>
            <p>Afin de vous apportez les meilleures solutions et le meilleur service, Geneva Web est né de la collaboration entre des entreprises spécialisées dans leur domaine. La complémentarité de ces dernières fait que nous pouvons apporter des solutions solides à nos clients.</p>
          </div>
          <div class="partenaires-content-container">
            <div>
              <div>
                <svg class="g3dev-logo" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 800 800" style="enable-background:new 0 0 800 800;" xml:space="preserve">             
                <g>
                  <path class="st0" d="M503.67,570.71l-2.13,3.09l-101.31-69.91l2.13-3.09C436.12,524.1,469.89,547.4,503.67,570.71L503.67,570.71z
                    M349.2,482.89l-99.42,64.05l-2.04-3.16l99.42-64.05C347.84,480.78,348.52,481.84,349.2,482.89L349.2,482.89z M551.44,536.54
                    l-1.98,3.2l-111.1-68.63l1.98-3.2C477.37,490.8,514.4,513.67,551.44,536.54L551.44,536.54z M609.49,492.33
                    c0.21,0.04,0.39,0.1,0.58,0.18l57.93,29.3c0.16,0.09,0.2,0.11,0.34,0.22c0.26,0.21,0.47,0.5,0.58,0.82
                    c0.07,0.19,0.11,0.39,0.11,0.6c0.02,0.99-0.76,1.84-1.74,1.91c-0.35,0.03-0.67-0.06-0.98-0.2l-57.93-29.3
                    c-0.3-0.17-0.56-0.38-0.74-0.68c-0.52-0.83-0.3-1.97,0.51-2.53c0.29-0.2,0.6-0.29,0.95-0.34
                    C609.28,492.31,609.28,492.31,609.49,492.33L609.49,492.33z M313.97,411.5c0.3,0.11,0.39,0.12,0.66,0.32
                    c0.71,0.53,0.95,1.51,0.57,2.31c-0.11,0.22-0.26,0.42-0.44,0.59c-0.09,0.08-0.2,0.14-0.3,0.22l-184,109.15
                    c-0.11,0.05-0.22,0.11-0.33,0.15c-0.23,0.08-0.48,0.12-0.73,0.11c-0.24-0.02-0.49-0.08-0.71-0.18c-0.8-0.38-1.23-1.3-1.01-2.16
                    c0.09-0.36,0.29-0.69,0.56-0.93c0.09-0.08,0.2-0.15,0.3-0.22l184-109.14c0.29-0.14,0.36-0.2,0.69-0.24
                    c0.12-0.02,0.24-0.01,0.37-0.02C313.73,411.46,313.85,411.48,313.97,411.5L313.97,411.5z M465.26,406.23
                    c0.21,0.04,0.27,0.04,0.47,0.12c0.08,0.03,0.15,0.07,0.22,0.11l87.09,49.7c0.18,0.12,0.23,0.14,0.39,0.3
                    c0.23,0.23,0.4,0.52,0.49,0.84c0.25,0.9-0.23,1.87-1.08,2.23c-0.23,0.09-0.47,0.14-0.72,0.15c-0.34,0-0.64-0.1-0.94-0.25
                    l-87.09-49.7c-0.28-0.18-0.52-0.39-0.69-0.68c-0.51-0.88-0.21-2.06,0.68-2.57c0.29-0.17,0.6-0.23,0.94-0.26
                    C465.1,406.22,465.18,406.22,465.26,406.23L465.26,406.23z M592.86,325.95c0.26,0.06,0.26,0.06,0.51,0.15l96.36,43.2
                    c0.08,0.05,0.16,0.08,0.24,0.13c0.23,0.14,0.42,0.33,0.57,0.56c0.1,0.15,0.17,0.32,0.23,0.48c0.3,0.98-0.28,2.05-1.26,2.34
                    c-0.34,0.11-0.71,0.11-1.06,0.01c-0.09-0.02-0.17-0.06-0.25-0.09l-96.36-43.2c-0.08-0.04-0.16-0.08-0.24-0.13
                    c-0.23-0.14-0.42-0.33-0.57-0.56c-0.56-0.86-0.31-2.04,0.55-2.6c0.22-0.15,0.48-0.24,0.74-0.29c0.09-0.01,0.18-0.01,0.27-0.02
                    C592.68,325.94,592.77,325.95,592.86,325.95L592.86,325.95z M360.53,262.14l-3.76,0.03l-1.32-198.42l3.76-0.02
                    C359.65,129.86,360.09,196,360.53,262.14L360.53,262.14z M442.2,261.72l-3.76,0.03l-1.32-198.42l3.76-0.02
                    C441.32,129.44,441.76,195.58,442.2,261.72L442.2,261.72z"/>
                  <path class="st1" d="M385.63,355.13l1.94,157.01l-81.44-58.66l-0.67-45.58L90.66,275.25l40.53,246.61l117.32,94.16l-0.76-72.32
                    L387.52,648.7l1.31,143.3L82.71,548.08l-71-410.15L385.63,355.13L385.63,355.13z M393.52,355.2l391.25-211.59l-62.35,394.1
                    L396.72,791.97l-1.32-143.39l108.26-77.88l-1.26,72.55l163.94-119.96l6.36-71.99l-123.23,88.46l1.92-82.61l136.15-85.97
                    l10.55-95.37L474.09,408.15l0.4,53.1l-79.03,51.17L393.52,355.2L393.52,355.2z M13.6,131.16L399.79,5l383.66,132L389.33,348.61
                    L13.6,131.16L13.6,131.16z M396.89,263.07l184.97-99.23l2.34-41.16L439.17,64.38l-82.23,0.51l-192.72,72.98L396.89,263.07
                    L396.89,263.07z"/>
                </g>
                </svg>
              </div>
              <h4>G3DEV</h4>
              <a href="http://www.geneva-3d.com/">geneva-3d.com</a>
              <ul>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Création de site internet</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>App mobile et desktop</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Développement d'interface</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Création de visite 360°</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Création 3D (WebGL)</li>
                
              </ul>
            </div>
            <div>
              <div>
                <svg class="zoomdesign-logo" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 35.2 35.2"  xml:space="preserve" width="200">
                  <g>
                    <polygon points="2.5,5 .75,4.25 0,2.5 .75,.75 2.5,0 31.5,0 26.5,5"></polygon>
                    <path class="contour" d="M31,0.2l-4.6,4.6H2.6c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3H31 M31.6,0L31.6,0L31.6,0z M31.6,0h-29
                    C1.2,0,0,1.2,0,2.6C0,4,1.2,5.1,2.6,5.1h23.9L31.6,0L31.6,0z"></path>
                  </g>

                  <g>
                    <polygon points="33.5,35 34.75,34.25 35,32.5 34.25,30.75 32.5,30.2 9,30.2 4,35"></polygon>
                    <path class="contour" d="M32.6,30.3L32.6,30.3c0.6,0,1.2,0.2,1.6,0.7c0.4,0.4,0.7,1,0.7,1.6c0,1.3-1,2.3-2.3,2.3H4.2l4.6-4.6H32.6
                    M32.7,30.1L32.7,30.1C32.6,30.1,32.6,30.1,32.7,30.1L32.7,30.1L32.7,30.1z M32.6,30.1H8.8l-5.1,5.1h29c0,0,0,0,0,0
                    c1.4,0,2.6-1.1,2.6-2.6C35.2,31.2,34.1,30.1,32.6,30.1L32.6,30.1z"></path>
                  </g>
                  <g>
                    <polygon class="st0 angle angletopleft" points="13.2,18.4 18.4,13.3 13.2,13.3 	" style="transform-origin: 0px 0px 0px;" data-svg-origin="15.799999713897705 15.849999904632568"> </polygon>
                  </g>
                  <g>
                    <polygon class="st0 angle anglebotright" points="22,16.8 16.9,21.9 22,21.9 	" style="transform-origin: 0px 0px 0px;" data-svg-origin="19.449999809265137 19.34999942779541"></polygon>
                  </g>

                </svg>
              </div>
              <h4>ZoomDesign</h4>
              <a href="http://zoomdesign.ch/">zoomdesign.ch</a>
              <ul>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Web design</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Expérience utilisateur UI/UX</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Créaton de site avec Wordpress</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Motion design</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Graphisme print</li>
              </ul>
            </div>
            <div>
              <div>
                <svg class="fivecollab-logo" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  width="178.667px" height="251.332px" viewBox="0 0 178.667 251.332">
                  <path fill="#FFFFFF" d="M164.432,122.132c-4.426-10.465-10.768-19.862-18.836-27.933c-8.069-8.071-17.47-14.408-27.935-18.833
                    c-10.831-4.584-22.342-6.908-34.207-6.908c-1.568,0-3.178,0.046-4.795,0.134l11.934-39.208h62.301V6.584H73.382l-29.464,97.572
                    l3.204-2.151C57.908,94.758,70.51,90.93,83.55,90.93c17.473,0,33.901,6.802,46.258,19.158
                    c12.349,12.353,19.156,28.782,19.156,46.253c0,17.473-6.808,33.898-19.156,46.254c-12.357,12.352-28.786,19.157-46.258,19.157
                    c-17.466,0-33.894-6.806-46.248-19.157c-4.105-4.101-7.592-8.656-10.423-13.543L7.354,200.333
                    c3.823,6.605,8.493,12.684,13.964,18.15c8.065,8.069,17.466,14.401,27.93,18.828c10.832,4.585,22.342,6.91,34.207,6.91
                    c11.865,0,23.375-2.325,34.207-6.91c10.465-4.427,19.865-10.759,27.935-18.828c8.068-8.069,14.41-17.471,18.836-27.937
                    c4.577-10.833,6.905-22.343,6.905-34.207C171.337,144.475,169.009,132.968,164.432,122.132"/>
                  <path fill="#FFFFFF" d="M83.596,183.649c-15.085,0-27.309-12.228-27.309-27.309c0-15.083,12.224-27.311,27.309-27.311
                    c10.106,0,18.931,5.492,23.653,13.654l19.522-11.272c-8.622-14.896-24.726-24.92-43.176-24.92c-27.53,0-49.849,22.319-49.849,49.849
                    c0,27.532,22.318,49.847,49.849,49.847c18.45,0,34.554-10.021,43.176-24.921l-19.522-11.272
                    C102.526,178.155,93.702,183.649,83.596,183.649"/>
                </svg>
              </div>
              <h4>Fivecollab</h4>
              <a href="https://fivecollab.com/">fivecollab.com</a>
              <ul>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Gestion de medias sociaux</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Ads facebook et instagram</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Créations publicitaires</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Marketing</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Web design</li>
              </ul>
            </div>
            <div>
              <div>
                <svg class="vse-logo"
                    xmlns:dc="http://purl.org/dc/elements/1.1/"
                    xmlns:cc="http://creativecommons.org/ns#"
                    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                    xmlns:svg="http://www.w3.org/2000/svg"
                    xmlns="http://www.w3.org/2000/svg"
                    id="svg8"
                    version="1.1"
                    viewBox="0 0 33.128849 33.623329"
                    height="33.623329mm"
                    width="33.128849mm">                    
                    <g
                      transform="translate(-0.07087278,-0.05245473)"
                      id="layer1">
                      <g
                        id="g59">
                        <ellipse
                          id="path21"
                          cx="5.1404777"
                          cy="8.3206844"
                          rx="5.0696049"
                          ry="5.2444196"
                          style="stroke-width:0.12236979" />
                        <ellipse
                          id="path21-3"
                          cx="28.130117"
                          cy="8.1818666"
                          rx="5.0696049"
                          ry="5.2444196"
                          style="stroke-width:0.1223698" />
                        <rect
                          id="rect38"
                          width="6.6263952"
                          height="21.698196"
                          x="13.276413"
                          y="0.052454729"
                          style="stroke-width:0.26273346" />
                        <rect
                          id="rect38-6"
                          width="21.969337"
                          height="6.630877"
                          x="5.590219"
                          y="27.044909"
                          style="stroke-width:0.26445931" />
                      </g>
                    </g>
                  </svg>


              </div>
              <h4>VSE</h4>
              <a href="https://www.volet-software.ch/">volet-software.ch</a>
              <ul>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Développement industriel</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Contrôle de prossessus</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Base de données</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Math et algorithmique</li>
                <li><i class="g3i g3i-carret-right g3i-sm"></i>Visualisation 2D/3D</li>
              </ul>
            </div>
          </div>
        </div>
        
      </div>
    </section>
    <section id="contact">
      <div class="wrap1140">
        <div class="section-header">
            <span class="section-title">contact</span>
            <h3>Vous souhaitez nous joindre ?</h3>
            <p>Vous avez envie d'en savoir plus ou tout simplement de boire un café ou un thé... <br>Pas de formulaire de contact austère, nous privilégions le contact humain.</p>
        </div>
        <div class="contact-content">
          <div>
            <div>
              <a :href="'tel:' + telLinkNumber">
                <i class="g3i g3i-phone"></i>
                <p>{{ telNumber }}</p>
              </a>
            </div>
            <div>
              <a :href="'mailto:' + emailAddress">
                <i class="g3i g3i-mail"></i>
                <p>{{ emailAddress }}</p>
              </a>
            </div>
            <div>
              <a href="https://www.google.com/maps/place/Geneva+3D+-+WEB+(g3dev+s%C3%A0rl)/@46.1958414,6.1287155,16.75z/data=!4m8!1m2!2m1!1sgen%C3%A8ve+3d!3m4!1s0x478c7b3536e62f31:0x88c84436d830fade!8m2!3d46.1960531!4d6.129645">
                <i class="g3i g3i-location"></i>
                <p>localisation</p>
              </a>
            </div>
          </div>
        </div>
        <footer>
          <div class="wrap1140">
            <div itemscope itemtype="http://schema.org/Organization" class="adress">
              <p itemprop="address" itemscope itemtype="http://schema.org/PostalAddress"> 
                <span itemprop="name"> G3Dev Sàrl</span> - 
                <span itemprop="streetAddress">Ch. de la gravière 2</span> - 
                <span itemprop="postalCode">1227</span> <span itemprop="addressLocality">les Acacias</span>
              </p>
            </div>
            <div class="discover">
              <p>Découvrez aussi</p>
              <div>
                <a href=""><img src="@/assets/logos/icon3D.svg" alt=""></a>
                <a href=""><img src="@/assets/logos/iconVr.svg" alt=""></a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </section>
  </div>
</template>

<script>

// @ is an alias to /src
import Header from '@/components/Header.vue'
import Tab from '@/components/Tab.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Tab
  },
  mounted () {
    
  },
  data() {
    return {
      telNumber: unescape('%30%32%32%20%35%33%35%20%34%31%20%37%37'),
      telLinkNumber: unescape('%30%30%34%31%32%32%35%33%35%34%31%37%37'),
      emailAddress: unescape('%69%6E%66%6F%40%67%33%64%65%76%2E%63%68')
    }
  },
}
</script>

<style lang="scss">
.home, .home section{
  height: auto;
  width: 100%;
  @include mq1280{
    height: auto;
  }
}

#services, #contact{
  background-color: $section-background;
  position: relative;
}
#contact{
  & > div{
    margin-bottom: 20vh;

  }
}

section{
  padding: 90px 10px;
  h2{
      color: $grey-text;
      font-family: $link-font;
      font-size: 32px;
      margin: 0 42px;
      span{
        background-color: $main-color;
        color: white;
        padding: 1px 10px 4px;
        border-radius: 4px;
        @include mq1024{
          background-color: transparent;
          color: $grey-text;
          padding: 0;
        }
      }
  }
  .sub-title{
    display: flex;
    justify-content: center;
    //text-transform: uppercase;
    padding: 15px 0;
    text-align: center;
    
  }
}

section:not(#contact) .wrap1140, section .wrap1280{
  height: 100%;
  width: 100%;
  & > div{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

#contact{
  height: 100%;
  width: 100%;
  & > div{
    height: calc(100% - 20vh);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}


.about-content{
  margin-top: 30px;
  &-col{
    display: flex;
    padding: 0 45px 0;
    justify-content: space-between;
    & > div{
      width: 33.33%;
      padding: 0 45px 45px 45px;
      text-align: center;
      img{
        width: 70%;
      }
      h4{
        font-size: 22px;
        letter-spacing: 0.2px;
        margin: 45px 0 15px;
      }
      p{
        font-size: 16px;
        line-height: 28px;
      }
    }
    @include mq768{
      flex-direction: column;
      & > div{
        width: 100%;
        padding: 0 0 45px 0;
        img{
          width: 180px
        }
      }
    }
  }
}
.section-header{
  text-align: center;
  margin-bottom: 60px;
  span.section-title{
    width: 100%;
    font-family: $sub-title-font;
    text-transform: uppercase;
    font-size: 14px;
    color: $main-color;
  }
  p{
    margin-top: 30px;
    max-width: 750px;
    line-height: 28px;
    margin-left: auto;
    margin-right: auto;
  }
}


.partenaires-content-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  & > div{
    width: 22%;
    padding: 30px;
    margin: 0 15px;
    text-align: center;
    border: 1px solid rgba($grey-text, .6);
    border-radius: 10px;
    @include mq1024{
      width: 40%;
      margin: 15px;
    }
    @include mq768{
      width: 80%;
      margin: 15px;
    }
  }
  svg{
    height: 92px;
    width: auto;
    .st0{fill-rule:evenodd;clip-rule:evenodd;}
    .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#010101;}
    &.zoomdesign-logo{
      height: 76px;
      margin: 9px 0 6px 0;
    }
    &.fivecollab-logo{
      height: 82px;
      margin: 9px 0 0 0;
    }
    &.vse-logo{
      height: 72px;
      margin: 14px 0 5px 0;
    }
  }
  h4{
    margin: 5px 0 5px 0;
    
    letter-spacing: 0.1px;
    
    color: $main-color;
    text-transform: uppercase;
  }
  a{
    display: block;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba($grey-text, .5);
    font-size: 14px;
    color: $grey-text;
  }
  ul{
    text-align: left;
    li{
      display: flex;
      font-family: $content-font;
      margin-bottom: 15px;
      .g3i{
        color: $main-color;
        margin-right: 10px;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
  path, polygon, ellipse, rect{
    fill: $grey-text !important;
  }
}

.contact-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  & > div{
      display: flex;
      justify-content: center;
      div{
        a{
          //background-color: $main-color;
          min-width: 210px;
          padding: 50px 40px;
          margin: 0 30px;
          color: white;
          display: block;
          text-align: center;
          border-radius: 8px;
          border: 1px solid $main-color;
          //box-shadow: 2px 2px 6px rgba(0,0,0,.2);
          transition: .2s;
          .g3i{
            font-size: 46px;
            margin-bottom: 15px;
            display: block;
            transition: .2s;
            color: $grey-text;          }
          p{
            font-family: $link-font;
            font-size: 20px;
            transition: .2s;
            color: $main-color;
          }
          &:hover{
            background-color: $main-color;
            box-shadow: 0 0 0 white;
            .g3i, p{
              color: white;
            }
          }
        }
      }
      @include mq768{
        flex-direction: column;
        div a{
          margin: 15px;
          padding: 15px 120px 5px;
          background-color: $main-color;
          .g3i, p{
            color: white;
          }
        }
      }
      @include mq576{
        flex-direction: column;
        div a{
          margin: 15px;
          padding: 15px 60px 5px;
          background-color: $main-color;
          .g3i, p{
            color: white;
          }
        }
      }
  }
}

footer{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20vh;
  background-color: $main-color;
  z-index: 1;
  .wrap1140{
    display: flex;
    height: 100%;
    flex-direction: column-reverse;
    padding: 35px 15px 2px;
    justify-content: space-between;
    text-align: center;
    p{
      color: rgba(white, .7);
      margin: 8px 0;
      font-size: 14px;
    }
    .discover p{
      font-size: 20px;
      font-family: $link-font;
      text-transform: uppercase;
      color: white;
    }
    .discover div{
      display: flex;
      justify-content: center;
      margin: 0 auto;
      
      a{
        display: block;
        margin: 0 5px;
        text-align: center;
        img{
          width: 72px;
          border-radius: 3px;
          background-color: rgba(white, 1);
        }
      }
    }
  }
}
</style>
